import $i18n from 'panda-i18n';

// 作业中滞留订单分布-人员维度
const PERSON_LINK_CODE = [
  {
    label: $i18n.get({ id: 'JHZ.Picking.four_px', dm: '拣货中' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'SortingInProgress.four_px', dm: '分拣中' }),
    value: 'Q',
  },

  {
    label: $i18n.get({ id: 'Packaging.four_px', dm: '打包中' }),
    value: 'R',
  },
];

// 库存异常监控
// 异常环节0:未知U:匹配，K:拣货，A:配货，B:打包S:签出
const INVENTORY_ERROR_NODE = [
  {
    label: $i18n.get({ id: 'Unknown', dm: '未知' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'Match.four_px', dm: '匹配' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: '31255239176884224.CNTM', dm: '拣货' }),
    value: 'K',
  },

  {
    label: $i18n.get({ id: 'Distribution', dm: '配货' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'CheckOut', dm: '签出' }),
    value: 'S',
  },
];

// 当前环节 O:未知U:匹配，C:拣货，A:配货，B:打包S:签出
const INVENTORY_ERROR_CURRENT_NODE = [
  {
    label: $i18n.get({ id: 'Unknown', dm: '未知' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'Match.four_px', dm: '匹配' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: '31255239176884224.CNTM', dm: '拣货' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Distribution', dm: '配货' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'CheckOut', dm: '签出' }),
    value: 'S',
  },
];

// 异常状态 "1：正常，2异常"
const INVENTORY_ERROR_STATUS = [
  {
    label: $i18n.get({ id: '31255237536911360.CNTM', dm: '正常' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'YC.Exception.four_px', dm: '异常' }),
    value: '2',
  },
];

// 是否影响对账，1：是，2：否
const INVENTORY_AFFECT_CHECK = [
  {
    label: $i18n.get({ id: 'Yes', dm: '是' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: '31255237809541120.CNTM', dm: '否' }),
    value: '2',
  },
];

// 异常环节 1、出库，2、入库，3、调整单
const INVENTORY_ERROR_LINK = [
  {
    label: $i18n.get({ id: '31255239722143744.CNTM', dm: '出库' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: '31255241957707776.CNTM', dm: '入库' }),
    value: '2',
  },

  {
    label: $i18n.get({ id: 'AdjustmentOrder.four_px', dm: '调整单' }),
    value: '3',
  },
];

const CONSIGMENT_STATUS = [
  {
    label: $i18n.get({ id: 'AuditedNumberChangeFailed', dm: '已审核(换号失败)' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'PendingOrder.four_px', dm: '待汇单' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'Matched.four_px', dm: '已匹配' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'cancel', dm: '取消' }),
    value: 'X',
  },

  {
    label: $i18n.get({ id: 'RemittanceInProgress.four_px', dm: '汇单中' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'OrdersReceived.four_px', dm: '已汇单' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'JHZ.Picking.four_px', dm: '拣货中' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'PickedUp.four_px', dm: '已拣货' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'SortingInProgress.four_px', dm: '分拣中' }),
    value: 'Q',
  },

  {
    label: $i18n.get({ id: 'Sorted.four_px', dm: '已分拣' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'PackingAfterPickingOrDistribution', dm: '打包中(拣货完成或配货完成后)' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'PackagedWarehouseCompletedPackagePacking', dm: '已打包仓库完成包裹打包' }),
    value: 'K',
  },

  {
    label: $i18n.get({ id: '31255240477118464.CNTM', dm: '已出库' }),
    value: 'S',
  },
];

const OUT_INVENTORY_STATUS = [
  {
    label: $i18n.get({ id: 'Matched.four_px', dm: '已匹配' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'PickedUp.four_px', dm: '已拣货' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Sorted.four_px', dm: '已分拣' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'Packaged.four_px', dm: '已打包' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'CheckedOut', dm: '已签出' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'NoMatch', dm: '未匹配' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },
];

// 中枢数据
// 任务类型
const CENTRAL_TASK_TYPE = [
  {
    label: 'S',
    value: 'S',
  },
  {
    label: 'SO',
    value: 'SO',
  },
  {
    label: 'MOD',
    value: 'MOD',
  },
];

export const EXPORTLIST_STATUS = [
  {
    label: $i18n.get({ id: 'InLine', dm: '排队中' }),
    value: 'QUEUING',
  },
  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'PROCESSING',
  },
  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'SUCCEED',
  },
  {
    label: $i18n.get({ id: 'SB.Failed.four_px', dm: '失败' }),
    value: 'FAILED',
  },
  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'CANCELLED',
  },
  {
    label: $i18n.get({ id: 'SB.Failed.four_px', dm: '失败' }),
    value: 'FAILED',
  },
];

// 看板维度 OC/PCS/PPO
const DASHBOARD_DIMENSION = [
  {
    label: $i18n.get({ id: 'OC.four_px', dm: 'OC' }),
    value: 'OC',
  },
  {
    label: $i18n.get({ id: 'PCS.four_px', dm: 'PCS' }),
    value: 'PCS',
  },
  {
    label: $i18n.get({ id: 'PPO.four_px', dm: 'PPO' }),
    value: 'PPO',
  },
];

// 库存异常监控服务名
const INVENTORY_MONITOR_SERVICE = '/inventory';

const INVENTORY_SERVICE = 'inventory/inventory';

const INVENTORY_INTELLIGENT = 'inventory/intelligent';

// 数字
const DATA_SERVICE = 'intelligent';

export {
  PERSON_LINK_CODE,
  INVENTORY_ERROR_NODE,
  INVENTORY_ERROR_CURRENT_NODE,
  INVENTORY_ERROR_STATUS,
  INVENTORY_AFFECT_CHECK,
  INVENTORY_ERROR_LINK,
  INVENTORY_MONITOR_SERVICE,
  INVENTORY_SERVICE,
  INVENTORY_INTELLIGENT,
  CONSIGMENT_STATUS,
  OUT_INVENTORY_STATUS,
  DATA_SERVICE,
  CENTRAL_TASK_TYPE,
  DASHBOARD_DIMENSION,
};
